import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StorageKeys } from '../app.constants';
import { Zone } from '../entities/creneaux/zone.model';
import { LoggingService } from '../shared/logging.service';
import { AbstractReadService } from './abstract.read.service';
import { OfflineNotificationService } from './offline-notification.service';
import { ServerUrl } from './server-url.service';
import { StorageService } from './storage.service';
import { UserEventWriteService } from './user-event.write.service';

@Injectable({ providedIn: 'root' })
export class ZonesReadService extends AbstractReadService<Zone[]> {
  private readonly prefix: string = '/api/zones/';

  constructor(
    http: HttpClient,
    storage: StorageService,
    offlineService: OfflineNotificationService,
    userEventWriteService: UserEventWriteService,
    private readonly serverUrl: ServerUrl,
    log: LoggingService
  ) {
    super(http, storage, offlineService, userEventWriteService, log);
  }

  public hydrate(obj: any): Zone[] {
    return obj.map(Zone.hydrate);
  }

  public getStorageKey(): string {
    return StorageKeys.ZONES;
  }

  public getResourceURL(param: any = null): string {
    return this.serverUrl.get() + '/..' + this.prefix;
  }
}
